import { useCallback, useEffect, useState } from 'react';

const TOP_OFFSET = 50;

export const setNavigationTheme = (theme: Theme) => {
  if (!window) return;

  document.documentElement.dataset.navTheme = `${theme}`;
};

export const getNavigationTheme = (): Theme => {
  if (!window) return null;

  return document.documentElement.dataset.navTheme as Theme;
};

export const useScrollTheme = (
  domNode: React.RefObject<HTMLDivElement>,
  themeName?: Theme,
) => {
  const theme = themeName || null;
  const [dictateTheme, setDictateTheme] = useState(false);

  const handleScroll = useCallback(() => {
    if (!domNode || !domNode.current || !window) return;

    const offTop = domNode.current.offsetTop;
    const offTopAndHeight =
      domNode.current.getBoundingClientRect().height + offTop;
    const scrolled = window.scrollY + TOP_OFFSET;

    if (offTop < scrolled && scrolled < offTopAndHeight) {
      if (!dictateTheme && theme) {
        setDictateTheme(true);
        setNavigationTheme(theme);
      }
    }

    if ((dictateTheme && offTop > scrolled) || scrolled > offTopAndHeight) {
      setDictateTheme(false);
    }
  }, [dictateTheme, setDictateTheme, domNode, theme]);

  useEffect(() => {
    if (!window) return;

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
};
